/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Notes/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Notes({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Notes",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#E17D46"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Notes.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-Z2iTIg6': alignSelf,'--mt-2-Z2iTIg6': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z2iTIg6': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z2iTIg6': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z2iTIg6': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z2iTIg6': opacity,'--w-10-Z2iTIg6': typeof width === 'number' ? `${width}px` : width,'--h-11-Z2iTIg6': typeof height === 'number' ? `${height}px` : height,'--f-12-Z2iTIg6': fill,'--a-7-Z2iTIg6': isAnimated ? animation : "none",'--sd-8-Z2iTIg6': isAnimated ? strokeDashoffset : 0,'--sd-9-Z2iTIg6': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Notes.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M3.5 4.5A1.5 1.5 0 015 3h7a1.5 1.5 0 011.5 1.5v9A1.5 1.5 0 0112 15H5a1.5 1.5 0 01-1.5-1.5v-.75h-.75a.75.75 0 010-1.5h.75v-1.5h-.75a.75.75 0 010-1.5h.75v-1.5h-.75a.75.75 0 010-1.5h.75V4.5zM16 5a.75.75 0 00-1.5 0v1A.75.75 0 0016 6V5zm-.75 2.75a.75.75 0 01.75.75v1a.75.75 0 01-1.5 0v-1a.75.75 0 01.75-.75zm-8-1.875a.625.625 0 100 1.25h2.5a.625.625 0 100-1.25h-2.5z"
 style={{'--f-12-Z2iTIg6': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}